import React from 'react';
import { motion } from 'framer-motion';

const HUDElement = ({
                        label,
                        value,
                        unit,
                        percentage,
                        variant = 'default',
                        className = ''
                    }) => {
    return (
        <motion.div
            className={`hud-element hud-element--${variant} ${className}`}
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4 }}
        >
            <div className="hud-element__header">
                <span className="hud-element__label">{label}</span>
                {percentage && (
                    <span className="hud-element__percentage">{percentage}%</span>
                )}
            </div>

            <div className="hud-element__value">
                {value}
                {unit && <span className="hud-element__unit">{unit}</span>}
            </div>

            {percentage && (
                <div className="hud-element__progress">
                    <motion.div
                        className="hud-element__progress-bar"
                        initial={{ width: 0 }}
                        whileInView={{ width: `${percentage}%` }}
                        transition={{ duration: 1, delay: 0.2 }}
                    ></motion.div>
                </div>
            )}

            <div className="hud-element__grid"></div>
        </motion.div>
    );
};

export default HUDElement;